import(/* webpackMode: "eager" */ "/vercel/path0/app/pdf-compressor/page.tsx");
